/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PumpDischargeGraphRequest
 */
export interface PumpDischargeGraphRequest {
  /**
   * simulation time in seconds
   */
  startTime: number;
  /**
   * Maximum number of points of history to return
   */
  historyPointsLimit?: number;
  /**
   * Subscribe for new results during simulation
   */
  subscribe: boolean;
  /**
   * Max number of items per second for subscription
   */
  subscribeRateLimit?: number;
  /**
   *
   */
  pumpId: number;
}

/**
 * Check if a given object implements the PumpDischargeGraphRequest interface.
 */
export function instanceOfPumpDischargeGraphRequest(
  value: object
): value is PumpDischargeGraphRequest {
  if (
    (!("startTime" in (value as Record<string, any>)) &&
      !("start_time" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["startTime"] === undefined &&
      (value as Record<string, any>)["start_time"] === undefined)
  )
    return false;
  if (!("subscribe" in value) || value["subscribe"] === undefined) return false;
  if (
    (!("pumpId" in (value as Record<string, any>)) &&
      !("pump_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["pumpId"] === undefined &&
      (value as Record<string, any>)["pump_id"] === undefined)
  )
    return false;
  return true;
}

export function PumpDischargeGraphRequestFromJSON(json: any): PumpDischargeGraphRequest {
  return PumpDischargeGraphRequestFromJSONTyped(json, false);
}

export function PumpDischargeGraphRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PumpDischargeGraphRequest {
  if (json == null) {
    return json;
  }
  return {
    startTime: json["start_time"],
    historyPointsLimit:
      json["history_points_limit"] == null ? undefined : json["history_points_limit"],
    subscribe: json["subscribe"],
    subscribeRateLimit:
      json["subscribe_rate_limit"] == null ? undefined : json["subscribe_rate_limit"],
    pumpId: json["pump_id"],
  };
}

export function PumpDischargeGraphRequestToJSON(json: any): PumpDischargeGraphRequest {
  return PumpDischargeGraphRequestToJSONTyped(json, false);
}

export function PumpDischargeGraphRequestToJSONTyped(
  value?: PumpDischargeGraphRequest | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    start_time: value["startTime"],
    history_points_limit: value["historyPointsLimit"],
    subscribe: value["subscribe"],
    subscribe_rate_limit: value["subscribeRateLimit"],
    pump_id: value["pumpId"],
  };
}
